// The one legacy adapter (WS-49, contract section 3). With no preset the page still runs through the one code path:
// today's inputs become the layers `resolve` reads. The implicit preset (every control today's config draws, the
// values `?embed` / `?kiosk` give: `legacy`, `legacy-embed`, `legacy-kiosk`) is built by the settings package from
// the registry's `legacy` data; today's browser-storage values are read here, raw. Pure: no DOM, no three.js.
import { legacyPreset as implicit } from './settings/index.js';
/** @typedef {import('./settings/typedefs.js').Registry} Registry */
/** @typedef {import('./settings/typedefs.js').Preset} Preset */

export const isLegacy = (preset) => ['legacy', 'legacy-embed', 'legacy-kiosk'].includes(preset?.id);

/**
 * The implicit preset of today's page.
 * @param {object} resort  resort.json as loaded (previews and draft merged, no season patch)
 * @param {Array<'embed' | 'kiosk'>} [modes]  the address flags present (both may be)
 * @returns {Preset}
 */
export const legacyPreset = (resort, modes = []) => implicit(resort, { embed: modes.includes('embed'), kiosk: modes.includes('kiosk') });

/**
 * Today's browser-storage values, raw, for the controls that own them (`<resort>` in a key stands for the resort id).
 * Read under the implicit legacy presets alone; a real preset uses the namespaced keys (runtime.js).
 * @param {Registry} registry
 * @param {Storage | null} storage
 * @param {string} resortId
 * @returns {{ [storageKey: string]: string }}
 */
export function legacyStored(registry, storage, resortId) {
  const out = {};
  try {
    for (const c of registry.controls) for (const k0 of c.store) {
      const k = k0.replace('<resort>', resortId), v = storage?.getItem(k);
      if (v != null) out[k] = v;
    }
  } catch { /* errors:ignore: storage blocked */ }
  return out;
}
